// extracted by mini-css-extract-plugin
export default {"img":"ProfileBtn_img__aXcvu","arrow":"ProfileBtn_arrow__zcT8l","link":"ProfileBtn_link__aoCLF","button":"ProfileBtn_button__4AWdP"};